import React, { Component } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import { filterCheckedColumns, moneyColumn, numVal, sessionItemByKeys } from '../../../../modules/Utils'
import { get, isEmpty } from 'lodash'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import BoolFilter from '../../../../elements/Select/BoolFilter'
import BoolCell from '../../../../elements/Table/Cells/BoolCell'

class OrderLinesList extends Component {
  render () {
    let columns = [
      {
        Header: 'Line No',
        accessor: 'no',
        Cell: ({ value, original }) => (
          <a onClick={e => this.props.onShowEditLine(e, original)}>{value || original.key}</a>
        ),
      },
      {
        Header: 'ID',
        accessor: '_id',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Product',
        accessor: 'product._id',
        width: 150,
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'To Ship',
        accessor: 'isShippable',
        filterMethod: filterCheckedColumns,
        Filter: BoolFilter,
        Cell: BoolCell,
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Description',
        accessor: 'description',
        hideable: true,
        hideDefault: true,
      },
      /*{
        Header: 'Fuel Tag',
        accessor: 'booking.vehicle.fuelTag',
        Cell: ({value}) => value === true && <Checkbox checked />,
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Pickup Date',
        accessor: 'booking.pickup.date',
        Cell: ({value}) => value && dateFormat(moment(value)),
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Drop off Date',
        accessor: 'booking.dropoff.date',
        Cell: ({value}) => value && dateFormat(moment(value)),
        hideable: true,
        hideDefault: true,
      },*/

      {
        Header: 'Invoiced',
        accessor: 'invoiced',
        hideable: true,
      },

      {
        Header: 'Quantity',
        accessor: 'unit',
        Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      },
      {
        Header: 'UoM',
        accessor: 'uom.code',
        //Cell: ({value}) => (typeof value === 'string' ? value : value.code),
      },
      {
        Header: 'Rate',
        accessor: 'rate',
        Cell: ({ value }) => moneyColumn(numVal({ value }, 'value')),
      },
      {
        Header: 'Sub-Total',
        accessor: 'amount.net',
        Cell: MoneyCell,
        Footer: SumFooter,
      },
      {
        Header: 'Tax',
        accessor: 'amount.tax',
        Cell: MoneyCell,
        Footer: SumFooter,
      },
      {
        Header: 'Total',
        accessor: 'amount.gross',
        Cell: MoneyCell,
        Footer: SumFooter,
      },
    ]
    const {
      type,
      lines,
      fetchLines,
      fetchingLines,
      formRef,
      onShowLine,
      onShowInvoice,
      actions,
    } = this.props
    const isUpdatable = type === 'new' || !!actions.find(a => a.key === 'update')
    if (!isUpdatable) {
      columns = columns.filter(c => c.accessor !== '_key')
    }
    return (
      <CustomTable
        columns={columns}
        defaultSorted={[
          {
            id: 'no',
            desc: false,
          },
        ]}
        data={lines}
        loading={fetchingLines}
        hide={{ refresh: type === 'new', create: !isUpdatable }}
        fetch={fetchLines}
        show={{ extraColumns: true }}
        ExtraButtons={() => (
          <Button
            style={{ marginLeft: 10 }}
            type={'dashed'}
            size={'small'}
            icon={'plus'}
            disabled={isUpdatable}
            onClick={onShowInvoice}>
            Invoice All
          </Button>
        )}
        CreateButton={() => (
          <Button
            type={'primary'}
            size={'small'}
            icon={'plus'}
            disabled={
              isEmpty(formRef.current) ||
              (formRef.current && !formRef.current.getFieldValue('contract._id'))
            }
            onClick={onShowLine}>
            Add Line
          </Button>
        )}
      />
    )
  }
}

OrderLinesList.propTypes = {}
OrderLinesList.defaultProps = {}

export default OrderLinesList
